export const VERIFY_ROUTE = '/verify';
